export const bankList = {
  ING: "ING",
  mBank: "mBank",
  NBP: "NBP",
  "BGŻ BNP Paribas": "BNP Paribas",
  "Deutsche Bank": "Deutsche Bank",
  "Pekao SA": "Pekao SA",
  "Raiffeisen Bank": "Raiffeisen Bank",
  "Alior Bank": "Alior Bank",
};
